/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergedUserAdminDelete
 */
export interface MergedUserAdminDelete {
    /**
     * 
     * @type {string}
     * @memberof MergedUserAdminDelete
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof MergedUserAdminDelete
     */
    org_user_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof MergedUserAdminDelete
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the MergedUserAdminDelete interface.
 */
export function instanceOfMergedUserAdminDelete(value: object): value is MergedUserAdminDelete {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('org_user_azure_id' in value) || value['org_user_azure_id'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function MergedUserAdminDeleteFromJSON(json: any): MergedUserAdminDelete {
    return MergedUserAdminDeleteFromJSONTyped(json, false);
}

export function MergedUserAdminDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergedUserAdminDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'org_user_azure_id': json['org_user_azure_id'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function MergedUserAdminDeleteToJSON(json: any): MergedUserAdminDelete {
    return MergedUserAdminDeleteToJSONTyped(json, false);
}

export function MergedUserAdminDeleteToJSONTyped(value?: MergedUserAdminDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'org_user_azure_id': value['org_user_azure_id'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

